/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Fragment } from "react";
import { Modal } from "react-bootstrap";
import {ActionType} from "./DataTable";

interface Props {
    key:any
    onAction:()=>any;
    disabled:boolean;
    type:ActionType;
    onCancel? : () => void
}
interface State {
    disabled?:boolean,
    show?:boolean,
    inProgress? : boolean
    
}

export class ToggleButton extends React.Component<Props,State>{
    constructor(props:Props) {
        super(props);
        this.state = {disabled : this.props.disabled,show:false,inProgress : false};
    }

    onClick() {
        this.props.onAction();
        this.setState({disabled:!this.state.disabled,show:false});
    }

    cancel() {
        this.setState({show : false});
        if(this.props.onCancel) {
            this.props.onCancel();
        }
    }

    getAction(){
        if(this.props.type === ActionType.BLOCK) {
            if(this.state.disabled) {
                return <a  key={"action-"+this.props.key} onClick={() => this.onClick()} className="btn btn-danger"><i className="fa fa-thumbs-up"></i> Unblock</a>;
            } else {
                return <a  key={"action-"+this.props.key} onClick={() => this.onClick()} className="btn btn-success"><i className="fa fa-thumbs-down"></i> Block  </a>;
            }
        }
        if(this.props.type === ActionType.DEFAULT) {
            if(this.state.disabled) {
                return <a  key={"action-"+this.props.key} onClick={() => this.onClick()} className="btn btn-danger"><i className="fa fa-thumbs-down"></i> Enable</a>;
            } else {
                return <a  key={"action-"+this.props.key} onClick={() => this.onClick()} className="btn btn-success"><i className="fa fa-thumbs-up"></i> Disable</a>;
            }
        }
    }

    getLabel() {
        if(this.state.disabled) {
            return "Unblock";
        }else{
            return "Block";
        }
    }

    getDescription() {
        if(this.state.disabled) {
            return "You are about to Unblock";
        }else{
            return "You are about to Block";
        }
    }

    getActions() {
        return (
            <div>
                <button className="btn btn-danger" onClick={this.onClick.bind(this)} disabled={this.state.inProgress}>{this.getLabel()}</button>
            </div>
        );
    }

    getModal(){
        return <Fragment>
            <Modal key={Math.random()} show={this.state.show} onHide={this.cancel.bind(this)}
                       aria-labelledby="contained-modal-title">
                    <Modal.Header  closeButton>
                        <Modal.Title id="contained-modal-title">Are sure you want to {this.getLabel()}?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.getDescription()}
                    </Modal.Body>
                    <Modal.Footer>
                       {this.getActions()}
                    </Modal.Footer>
                </Modal>
        </Fragment>
    }

    getButtonAction(){
        if(this.state.disabled) {
            return <Fragment><a  key={"action-"+this.props.key} onClick={() => this.setState({show : true })} className="btn btn-danger"><i className="fa fa-thumbs-up"></i> {this.getLabel()}</a></Fragment>
        }else{
            return <Fragment><a  key={"action-"+this.props.key} onClick={() => this.setState({show : true })} className="btn btn-success"><i className="fa fa-thumbs-down"></i> {this.getLabel()}  </a></Fragment>
        }
    }

    getResponse(){
        return [
            this.getButtonAction(),
            this.getModal()
        ];
    }
    
    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        if(this.state.disabled) {
            return this.getResponse();
        } else {
            return this.getResponse();
        }
    }

}